import { ApiAttachmentDeletedResponse, ApiAttachmentExistingResponse } from '@/shared/api';
import { COLORS } from '@/shared/constants/colors';
import { IconName } from '@/shared/uikit/Icon';

import { Tags, TaskPriority, UserStatus } from '../types';

export const getTagColor = (tag: Tags): string | undefined => {
  switch (tag) {
    case Tags.FAMILY:
      return COLORS.colorVfoTags[0];
    case Tags.LEGAL:
      return COLORS.colorVfoTags[1];
    case Tags.WEALTH:
      return COLORS.colorVfoTags[2];
    case Tags.TAX:
      return COLORS.colorVfoTags[3];
    case Tags.FINANCE:
      return COLORS.colorVfoTags[4];
    case Tags.MANAGEMENT:
      return COLORS.colorVfoTags[5];
    case Tags.LIFESTYLE:
      return COLORS.colorVfoTags[6];
    default:
      return COLORS.colorVfoTags[0];
  }
};

export const getStatusColor = (status: UserStatus, isVfoActivated: boolean): string => {
  if (!isVfoActivated) {
    return COLORS.systemSun200;
  }

  switch (status) {
    case UserStatus.ONLINE:
      return COLORS.systemForest200;
    case UserStatus.OFFLINE:
    default:
      return COLORS.systemDark100;
  }
};

export const isVfoTag = (tag?: string): tag is Tags => {
  return Object.values(Tags).includes(tag as Tags);
};

export const getPriorityColor = (priority: TaskPriority): string => {
  switch (priority) {
    case TaskPriority.HIGH:
      return COLORS.systemFlame200;
    case TaskPriority.MEDIUM:
      return COLORS.systemSun200;
    case TaskPriority.LOW:
      return COLORS.systemSky200;
    default:
      return COLORS.systemSun100;
  }
};

export const getPriorityIcon = (priority: TaskPriority): IconName => {
  switch (priority) {
    case TaskPriority.HIGH:
      return 'caret-double-up';
    case TaskPriority.LOW:
      return 'caret-double-down';
    case TaskPriority.MEDIUM:
    default:
      return 'equals';
  }
};

export const isHEIC = (file: File) => {
  const x = file.type ? file.type.split('image/').pop() : file.name.split('.').pop()?.toLowerCase();
  return x === 'heic' || x === 'heif';
};

export const isAttachmentDeleted = (
  file: ApiAttachmentDeletedResponse | ApiAttachmentExistingResponse,
): file is ApiAttachmentDeletedResponse => {
  return 'deleted' in file && file.deleted;
};
